import React from "react"
import styled from "styled-components"

const arrowTransform = (angle, x, y) => `
  i:first-child {
    transform: translate(${x}px, ${y}px) rotate(${angle}deg);
  }

  i:last-child {
    transform: translate(${x}px, ${-y}px) rotate(${-angle}deg);
  }
`

const PageButton = styled.button`
  -webkit-appearance: none;
  background: transparent;
  border: 0;
  outline: none;
  pointer-events: auto;

  &:focus {
    outline: none;
  }

  position: absolute;
  top: calc(50% - 20px);
  width: 30px;
  height: 30px;
  cursor: pointer;
  transform: translate3d(0, 0, 0);
  z-index: 1;

  -webkit-filter: drop-shadow(0 2px 0px rgba(0, 0, 0, 0.2));

  i {
    position: absolute;
    top: 40%;
    left: 0;
    width: 30px;
    height: 3px;
    border-radius: 2px;
    background: #fff;

    transition: all 0.15s ease;
  }

  &.left {
    margin-left: 10px;
    left: 0;

    i {
      transform-origin: 0% 50%;
    }

    ${arrowTransform(40, 0, -1)}

    &:hover {
      ${arrowTransform(30, 0, -1)}
    }

    &:active {
      ${arrowTransform(25, 1, -1)}
    }

    &[data-state="disabled"] {
      ${arrowTransform(0, -5, 0)}

      &:hover {
        ${arrowTransform(0, -5, 0)}
      }
    }
  }

  &.right {
    margin-right: 10px;
    right: 0;

    i {
      transform-origin: 100% 50%;
    }

    ${arrowTransform(40, 0, 1)}

    &:hover {
      ${arrowTransform(30, 0, 1)}
    }

    &:active {
      ${arrowTransform(25, 1, 1)}
    }

    &[data-state="disabled"] {
      ${arrowTransform(0, 5, 0)}

      &:hover {
        ${arrowTransform(0, 5, 0)}
      }
    }
  }

  &[data-state="disabled"] {
    opacity: 0.3;
    cursor: default;
  }
`

const PageArrow = ({ dir, enabled, ...rest }) => (
  <PageButton className={dir} {...rest} data-state={enabled ? "" : "disabled"}>
    <i></i>
    <i></i>
  </PageButton>
)

export default PageArrow
